<template>
    <div class="company-info">
        <div>
            <el-button size="mini" round @click="loadTable('info')">工商基础信息</el-button>
            <el-button size="mini" round @click="loadTable('qualification_certificates')">资质证书</el-button>
        </div>
        <div style="padding: 0.2rem;">
            <base-info class="dimension-style" :info="company_info" v-if="active === 'info'" />
            <qualification-certificates class="dimension-style" :tableData="qualification_certificates" v-if="active === 'qualification_certificates'" />
        </div>
    </div>
</template>

<script>
import BaseInfo from './BaseInfo'
import QualificationCertificates from './QualificationCertificates'
export default {
    name: 'CompanyInfo',
    components: { BaseInfo, QualificationCertificates },
    props: {
        call_task_id: {
            type: String
        }
    },
    data() {
        return {
            active: 'info',
            company_info: {},
            qualification_certificates: []
        }
    },
    watch: {
        call_task_id: {
            immediate: true,
            handler(n) {
                if (n) {
                    this.loadTable()
                } else {
                    this.company_info = {}
                }
            }
        }
    },
    methods: {
        loadTable(active) {
            if (active) this.active = active
            this.$axios.get('api/api3_call_task/load_info', {
                params: {
                    id: this.call_task_id,
                    active: this.active
                }
            }).then(({ data }) => {
                if (data.code === 0) {
                    if (this.active === 'info') {
                        this.company_info = data.data
                    }else if(this.active === 'qualification_certificates') {
                        this.qualification_certificates = data.data
                    }
                }
            }).catch()
        }
    },
}
</script>

<style scoped>
.company-info .dimension-style {
    overflow-y: auto;height: 80vh;
}
</style>


// WEBPACK FOOTER //
// src/pages/cloudClue/Components/CompanyInfo.vue